import ExperiencesList from './ExperiencesList';
import Item from './Item';

export default Object.assign(ExperiencesList, { Item });
